import { render, staticRenderFns } from "./resumeInit.vue?vue&type=template&id=70113f56"
import script from "./resumeInit.vue?vue&type=script&lang=js"
export * from "./resumeInit.vue?vue&type=script&lang=js"
import style0 from "./resumeInit.vue?vue&type=style&index=0&id=70113f56&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports